import { createFileRoute } from "@tanstack/react-router";
import { BviFormations } from "@/components/Compliance/Bvi/Formations";

export const Route = createFileRoute("/_authenticated/compliance/bvi/formations/")({
  component: BviFormations,
  staticData: { page: "compliance" },
});
